const handleTabs = ( tabsGroup ) => {
    const tabsBtns = tabsGroup.querySelectorAll('.cb-tab-link');
    const tabs = tabsGroup.querySelectorAll('.cb-tab');

    tabsBtns.forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            const 
                activeTabLink = tabsGroup.querySelector('.cb-tab-link.active'),
                activeTab     = tabsGroup.querySelector('.cb-tab.active-tab'),
                index         = el.dataset.index;

            if ( activeTabLink ) {
                activeTabLink.classList.remove('active');
            }

            if ( activeTab ) {
                activeTab.classList.remove('active-tab');
            }

            el.classList.add('active');

            tabsGroup.querySelector(`.cb-tabs .cb-tab:nth-child(${parseInt(index) + 1})`).classList.add('active-tab');
        });
    });
}

const tabs = document.querySelectorAll('.wp-block-cb-tabs');

if ( tabs ) {
    tabs.forEach((el) => handleTabs(el));
}